/* global gsap */
(function f() {
    // create a oop object
    class VideoCarousel {
        constructor({ items, dotsContainer, arrowLeft, arrowRight }) {
            if (!items || !items.length) {
                this.invalid = true;
                return;
            }

            this.items              = items;
            this.current            = items[0];
            this.dotsContainer      = dotsContainer;
            this.arrowLeft          = arrowLeft;
            this.arrowRight         = arrowRight;
            this.container          = items[0].parentNode;
            this.innerContainer     = document.createElement('div');
            this.dotsInnerContainer = document.createElement('ul');
            this.dotItems           = [];
            this.itemsTL            = [];
            this.arrows             = { left: '', right: '' };
            this.pressed            = false;
            this.startX;
            this.endX;

            this.init();
        }

        createArrow(direction, color = '#fff') {
            // create arrow svg
            const svg     = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            const polygon = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
            const button  = document.createElement('button');

            svg.setAttribute('viewBox', '0 0 32 30');
            polygon.setAttribute('points', direction === 'left' ? '15.49 0 17.91 2.65 6.62 13.39 32 13.46 31.93 16.64 6.55 16.56 17.92 27.57 15.6 30 0 14.97 15.49 0' : '16.51 30 14.09 27.35 25.38 16.61 0 16.54 .07 13.36 25.45 13.44 14.08 2.43 16.4 0 32 15.03 16.51 30');
            polygon.setAttribute('fill', color);
            svg.appendChild(polygon);
            button.appendChild(svg);
            button.classList.add('carousel__arrow');
            button.classList.add(`carousel__arrow-${direction}`);
            button.setAttribute('aria-label', direction === 'left' ? 'Previous' : 'Next');
            button.setAttribute('aria-controls', 'carousel');
            button.setAttribute('aria-disabled', 'false');
            button.setAttribute('type', 'button');
            button.setAttribute('tabindex', '0');

            this.arrows[direction] = button;
            return button;
        }

        updateActiveDot(index) {
            this.dotItems.forEach((dot, i) => dot.setAttribute('aria-selected', i === index));
            if (index === 0) {
                this.arrows.left.setAttribute('disabled', true);
                this.arrows.left.setAttribute('aria-disabled', true);
            } else {
                this.arrows.left.removeAttribute('disabled');
                this.arrows.left.setAttribute('aria-disabled', false);
            }
            if (index === this.dotItems.length - 1) {
                this.arrows.right.setAttribute('disabled', true);
                this.arrows.right.setAttribute('aria-disabled', true);
            } else {
                this.arrows.right.removeAttribute('disabled');
                this.arrows.right.setAttribute('aria-disabled', false);
            }
        }

        updateContainerHeight() {
            gsap.to(this.innerContainer, { height: window.getComputedStyle(this.current).height, duration: 0.3 });
        }

        goTo(targetIndex, duration = 0.6) {
            if (this.invalid) return;

            const isAnimating = this.itemsTL.some(tl => tl.isActive());

            if (isAnimating) return;

            const currentIndex = this.items.indexOf(this.current);

            if (targetIndex === 'next')
                targetIndex = currentIndex + 1;
            else if (targetIndex === 'prev')
                targetIndex = currentIndex - 1;

            // Abort if the target is not there.
            if (!this.items[targetIndex]) return;

            this.items.forEach((item, i) => {
                const itemConf = { xPercent: 0, yPercent: 0, opacity: 1, duration, scale: 0.6, zIndex: 1, pointerEvents: 'none', transformOrigin: 'center' };
                this.itemsTL[i] = gsap.timeline();
                if (i < targetIndex - 1) {
                    // if i is less than targetIndex by more than 1
                    itemConf.xPercent  = 0;
                    itemConf.yPercent  = -10;
                    itemConf.zIndex    = 0;
                    itemConf.scale     = 0.3;
                    itemConf.onComplete = () => gsap.set(item, { opacity: 0 });
                    itemConf.transformOrigin = 'center left';
                    item.style.zIndex  = 0;
                } else if (i > targetIndex + 1) {
                    // if i is more than targetIndex by more than 1
                    itemConf.xPercent  = 0;
                    itemConf.yPercent  = -10;
                    itemConf.zIndex    = 0;
                    itemConf.scale     = 0.3;
                    itemConf.onComplete = () => gsap.set(item, { opacity: 0 });
                    itemConf.transformOrigin = 'center right';
                    item.style.zIndex  = 0;
                } else if (i === targetIndex - 1) {
                    // if item is exactly one less (left)
                    itemConf.xPercent = -8;
                    itemConf.yPercent = -10;
                    itemConf.duration = duration / 2;
                    item.style.opacity = 1;
                    itemConf.transformOrigin = 'center left';
                } else if (i === targetIndex + 1) {
                    // If item is exactly one more (right)
                    itemConf.xPercent = 8;
                    itemConf.yPercent = -10;
                    item.style.opacity = 1;
                    itemConf.duration = duration / 2;
                    itemConf.transformOrigin = 'center right';
                    // Target
                } else if (i === targetIndex) {
                    itemConf.scale  = 1;
                    itemConf.zIndex = 3;
                    itemConf.pointerEvents = '';
                    itemConf.transformOrigin = currentIndex < targetIndex ? 'center right' : 'center left';
                    this.current = item;
                    this.updateContainerHeight();
                }

                // Fire the animation
                this.itemsTL[i].to(item, itemConf);
            });

            this.updateActiveDot(targetIndex);
        }

        showNextItem() { this.goTo('next'); }

        showPrevItem() { this.goTo('prev'); }

        mouseDown(e) {
            const touch = e.type === 'touchstart';
            this.startX  = touch ? e.touches[0].clientX : e.offsetX;
            this.endX    = this.startX;
            this.pressed = true;
            this.innerContainer.style.cursor = 'grabbing';
        }

        mouseEnter() {
            this.innerContainer.style.cursor = 'grab';
        }

        mouseUp() {
            const moved     = this.endX - this.startX;
            const direction = moved > 0 ? 'prev' : 'next';
            const amount    = Math.abs(moved);
            this.innerContainer.style.cursor = 'grab';
            this.pressed = false;
            if (amount > 40)
                this.goTo(direction);
        }

        mouseMove(e) {
            if (!this.pressed) return;
            this.endX = e.type === 'touchmove' ? e.touches[0].clientX : e.offsetX;
        }

        init() {
            // Put it together.
            this.innerContainer.classList.add('carousel');
            this.dotsInnerContainer.classList.add('carousel__dots');
            this.dotsContainer.appendChild(this.dotsInnerContainer);
            this.container.appendChild(this.innerContainer);

            if (this.arrowLeft) {
                this.createArrow('left', 'var(--secondary)');
                this.arrowLeft.appendChild(this.arrows.left);
                this.arrowLeft.classList.add('carousel__arrow-container');
                this.arrows.left.addEventListener('click', this.showPrevItem.bind(this));
            }

            if (this.arrowRight) {
                this.createArrow('right', 'var(--secondary)');
                this.arrowRight.appendChild(this.arrows.right);
                this.arrowRight.classList.add('carousel__arrow-container');
                this.arrows.right.addEventListener('click', this.showNextItem.bind(this));
            }

            this.items.forEach((item, index) => {
                this.dotItems[index] = document.createElement('li');
                this.dotItems[index].classList.add('carousel__dot');
                this.dotItems[index].setAttribute('role', 'tab');
                this.dotItems[index].setAttribute('aria-selected', 'false');
                this.dotItems[index].setAttribute('aria-controls', 'dots');
                this.dotItems[index].setAttribute('aria-label', `Slide ${index + 1}`);
                this.dotItems[index].setAttribute('data-index', index);
                this.dotsInnerContainer.appendChild(this.dotItems[index]);

                item.classList.add('carousel__item');
                this.innerContainer.appendChild(item);

                this.dotItems[index].addEventListener('click', () => this.goTo(index));
                this.goTo(0, 0);
            });

            this.innerContainer.addEventListener('mousedown', this.mouseDown.bind(this));
            this.innerContainer.addEventListener('touchstart', this.mouseDown.bind(this));
            this.innerContainer.addEventListener('mouseenter', this.mouseEnter.bind(this));
            this.innerContainer.addEventListener('mouseup', this.mouseUp.bind(this));
            this.innerContainer.addEventListener('touchend', this.mouseUp.bind(this));
            this.innerContainer.addEventListener('mousemove', this.mouseMove.bind(this));
            this.innerContainer.addEventListener('touchmove', this.mouseMove.bind(this));

            window.addEventListener('resize', this.updateContainerHeight.bind(this));

            return this;
        }
    }

    window.VideoCarousel = VideoCarousel;
}());
